import { AuthManager } from 'utils/authManager';
import BrowserHistory from '@ps/payscale-shared-ui/lib/BrowserHistory';
import StorageManager from 'utils/storageManager';
import DataManager from 'utils/dataManager';

let authManager: AuthManager;
let history: BrowserHistory;
let storageManager: StorageManager;
let dataManager: DataManager;

export const init = (localStorage: Storage, sessionStorage: Storage) => {
    history = new BrowserHistory(window);
    storageManager = new StorageManager(localStorage, sessionStorage);
    authManager = new AuthManager(); // authManager depends on storage
    dataManager = new DataManager(authManager);
};

export {
    authManager,
    dataManager,
    history,
    storageManager };



// WEBPACK FOOTER //
// ./src/singletons.ts